import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	starred: {
		id: 'atlassian-navigation.plans.menu.favorite-content.starred',
		defaultMessage: 'Starred',
		description: 'The STARRED title.',
	},
	untitledPlan: {
		defaultMessage: 'Untitled plan',
		id: 'atlassian-navigation.plans.menu.favorite-content.untitled-plan',
		description: 'Default title for Advanced Roadmap dropdown items in the top bar navigation',
	},
});
